import React, { useEffect } from "react";
import Form from "react-bootstrap/Form";
import { Button } from "reactstrap";
import {
  deleteSingleProperty,
  downloadDocument1,
  fetchNetWorth,
  getBeneficiary,
  getOwnerByUserId,
  getSecondaryUser,
  getToken,
  getTrustByUserId,
  getUser,
} from "../../services/user-service";

import { FormControlLabel, Switch, Tooltip, Typography } from "@mui/material";

import {
  FormHelperText,
  FormLabel,
  Input,
  Option,
  Select,
  Textarea,
} from "@mui/joy";

import {
  faDownload,
  faHouse,
  faMinus,
  faPlus,
  faTrash,
  faTriangleExclamation,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { useState } from "react";
import { toast } from "react-toastify";
import {
  formatAmount,
  validateEightDigitNumber,
  formatDateTimeUS,
} from "../../components/Common";
import SharedBeneficiary from "../../components/SharedBeneficiary";
import "../../css/myestare.css";
import {
  deleteRealEstate,
  getRealEstates,
  realEstates,
} from "../../services/RealEstate-service";
import "./../../css/formPOPup.css";
import Deletebutton from "./Deletebutton";
import UpdateButton from "./UpdateButton";

function RealEstateContent() {
  // set Add data
  const [data, setData] = useState({
    realEstate: {
      owner: "",
      propertyCaption: "",
      propertyType: "",
      otherPropertyType: "",
      aptNumber: "",
      streetAddress: "",
      estPropertyVal: "",
      isPartOfNetWorth: "true",
      isPublic: "true",
      zipCode: "",
      country: "",
      propertyTax: "",
      city: "",
      state: "",
      trust: "",
      notes: "",
    },
    mortgages: [
      {
        mortgage: "",
        mortgageInstitution: "",
        accountNumber: "",
      },
    ],
    sharedDetails: [
      {
        distributedType: "",
        distributedValue: "",
        distributedAmount: "",
        beneficiaryId: "",
      },
    ],
  });

  const [errors, setErrors] = useState({
    estPropertyValValidate: true,
    propertyTaxValidate: true,
    estPropertyValZeroValidate: true,
    propertyTaxZeroValidate: true,
    mortgages: [],
  });

  const [ownerName, setOwnerName] = useState([]);
  const handleChange = (event, newValue, stringValue) => {
    if (stringValue === "propertyType") {
      setData((prevData) => ({
        ...prevData,
        realEstate: {
          ...prevData.realEstate,
          propertyType: newValue,
          otherPropertyType: newValue !== "Other" ? "" : "",
        },
      }));
    }

    if (stringValue === "owner") {
      const comingValue =
        typeof newValue === "string" ? newValue.split(",") : newValue;
      const ownerString = comingValue.join(", ");

      setData((prevData) => ({
        ...prevData,
        realEstate: {
          ...prevData.realEstate,
          owner: ownerString,
        },
      }));

      // Update the ownerName state afterwards
      setOwnerName(newValue);
    }
  };

  // Define an array to store user names
  const [ownerNames, setOwnerNames] = useState([]);

  // Get primaryUser data
  const primaryUserDetails = getUser();
  const primaryUserName =
    primaryUserDetails.firstName + " " + primaryUserDetails.lastName;

  // Get secondaryUser data
  const secondaryUserDetails = getSecondaryUser();
  useEffect(() => {
    const fetchOwnerData = async () => {
      const userId = getUser().commonId;
      const token = "Bearer " + getToken();

      try {
        const resp = await getOwnerByUserId(token, userId);
        // Process data after fetching
        const names = [primaryUserName];

        // Check if secondary user exists
        if (secondaryUserDetails !== undefined) {
          const secondaryUserName = `${secondaryUserDetails.firstName} ${secondaryUserDetails.lastName}`;
          names.push(secondaryUserName);
        }
        resp.forEach((user) => {
          const fullName = `${user.firstName} ${user.lastName}`;
          names.push(fullName);
        });

        // Update ownerNames state
        setOwnerNames(names);
      } catch  {
        toast.error("Failed to fetch owner data");
      }
    };

    fetchOwnerData();
  }, []);

  // use state to set the selected images
  const [selectedImage, setSelectedImage] = useState(null);
  const [sharedType, setSharedType] = useState(null);
  const handleChanges = (e, field) => {
    let newValue = e.target.value;
    const errorStates = { ...errors };

    if (field === "sharedType") {
      setSharedType(newValue);

      setData((prevData) => {
        const resetSharedDetails = [
          {
            distributedType: "",
            distributedValue: "",
            distributedAmount: "",
            beneficiaryId: "",
          },
        ];

        return {
          ...prevData,
          sharedDetails: resetSharedDetails,
        };
      });
      setData((prevData) => ({
        ...prevData,
        realEstate: {
          ...prevData.realEstate,
          trust: "",
        },
      }));
    } else {
      if (field === "estPropertyVal" || field === "propertyTax") {
        if (field === "estPropertyVal") {
          errorStates.estPropertyValValidate =
            newValue !== "" ? validateEightDigitNumber(newValue) : true;
          errorStates.estPropertyValZeroValidate =
            newValue !== "" ? Number(newValue) > 0 : true;
        } else {
          errorStates.propertyTaxValidate =
            newValue !== "" ? validateEightDigitNumber(newValue) : true;
          errorStates.propertyTaxZeroValidate =
            newValue !== "" ? Number(newValue) > 0 : true;
        }
      } else if (field === "isPartOfNetWorth") {
        newValue =
          data.realEstate.isPartOfNetWorth === "false" ? "true" : "false";
      }else if (field === "isPublic") {
               newValue =
                 data.realEstate.isPublic === "false" ? "true" : "false";
      }
      else {
      }
      setData((prevData) => ({
        ...prevData,
        realEstate: {
          ...prevData.realEstate,
          [field]: newValue,
        },
      }));
    }
    const totalBalance = data.realEstate.estPropertyVal;
    setEstimatedTotalAmount(totalBalance);
    setErrors(errorStates);
  };
  const handleImageChange = (event) => {
    const selectedFiles = event.target.files;
    const allowedExtensions = ["pdf"];
    const maxFileSize = 4 * 1024 * 1024;

    if (selectedFiles) {
      const selectedFilesArray = Array.from(selectedFiles);

      const invalidFiles = selectedFilesArray.filter((file) => {
        const fileNameParts = file.name.split(".");
        const fileExtension =
          fileNameParts[fileNameParts.length - 1].toLowerCase();
        const isInvalidExtension = !allowedExtensions.includes(fileExtension);
        const isTooLarge = file.size > maxFileSize;
        return isInvalidExtension || isTooLarge;
      });

      if (invalidFiles.length === 0) {
        const formData = new FormData();
        selectedFilesArray.forEach((file, index) => {
          formData.append(`file${index + 1}`, file);
        });
        setSelectedImage(selectedFilesArray);
      } else {
        toast.error("Please upload a valid PDF under 4 MB.", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        event.target.value = "";
      }
    }
  };

  const resetForm = () => {
    setVisibleColumnIndex(0);
    setData({
      realEstate: {
        owner: "",
        propertyCaption: "",
        propertyType: "",
        otherPropertyType: "",
        aptNumber: "",
        streetAddress: "",
        estPropertyVal: "",
        isPartOfNetWorth: "true",
        zipCode: "",
        country: "",
        propertyTax: "",
        city: "",
        state: "",
        trust: "",
        notes: "",
      },
      mortgages: [
        {
          mortgage: "",
          mortgageInstitution: "",
          accountNumber: "",
        },
      ],
      sharedDetails: [
        {
          distributedType: "",
          distributedValue: "",
          distributedAmount: "",
          beneficiaryId: "",
        },
      ],
    });
    setOwnerName([]);
    handleReset();
    setIsChecked(false);
    setSharedType(null);
    setErrors({
      estPropertyValValidate: true,
      propertyTaxValidate: true,
      estPropertyValZeroValidate: true,
      propertyTaxZeroValidate: true,
      mortgages: [],
    });
  };

  const [isChecked, setIsChecked] = useState(false);
  const handleSwitchChange = () => {
    setIsChecked((prev) => !prev);
  };

  // Set the form
  const AddForm = (event) => {
    event.preventDefault();
  
    // Check if there are any errors
    const hasErrors =
      Object.values(errors).includes(false) ||
      errors.mortgages.some((mortgage) => !mortgage.mortgageAmountValidate);
  
    if (!hasErrors) {
      let token = "Bearer " + getToken();
  
      // Create form data to send a file and remaining class data
      const formData = new FormData();
      if (selectedImage !== null) {
        for (let i = 0; i < selectedImage.length; i++) {
          formData.append("files", selectedImage[i]);
        }
      }
      formData.append("data", JSON.stringify(data));
  
   
      //  Fix: Call realEstates function instead of returning early
      realEstates(formData, token)
        .then((resp) => {
          AddCard();
          toast.success("Data Added !!", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          fetchNetWorth(primaryUserDetails.commonId);
          toggle();
        })
        .catch((error) => {
          toast.error(
            "File is too large, please choose a file size under 400 KB",
            error
          );
        });
    }
  };
  

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [currentIdType, setCurrentIdType] = useState("");
  const removeRealEstate = (id, idType) => {
    setShowConfirmation(true);
    setCurrentId(id);
    setCurrentIdType(idType);
  };

  const handleConfirmationClose = () => {
    setShowConfirmation(false);
  };

  // code by purnendu
  const handleRemove = (params) => {
    setShowConfirmation(false);
    const { Id, idType } = params;
    if (idType === "realEstateId") {
      deleteRealEstate(Id)
        .then((res) => {
          toast.success("Deleted successfully...", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          fetchNetWorth(primaryUserDetails.commonId);
          AddCard();
          setShow(false);
        })
        .catch((err) => {});
    } else {
      deleteSingleProperty(Id)
        .then((res) => {
          fetchNetWorth(primaryUserDetails.commonId);
          setBeneficiaryVisible(!beneficiaryVisible);
          setShow(false);
          AddCard();
          toast.success("Deleted successfully...", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        })
        .catch((error) => {});
    }
  };
  // code for handle download
  const handleDownload = (id, fileName) => {
    let myarry = fileName.split(".");

    downloadDocument1(id)
      .then((response) => {
        const downloadUrl = URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `${myarry[0]}.${myarry[1]}`;
        link.click();
        URL.revokeObjectURL(downloadUrl);
      })
      .catch((error) => {});
  };

  const handleChangesZipCode = (e, field) => {
    const inputValue = e.target.value;
    if (/^\d{0,5}$/.test(inputValue)) {
      // Validation to allow only up to 5 digits (or empty string)
      // setData({ ...data, [field]: inputValue });
      setData((prevData) => ({
        ...prevData,
        realEstate: {
          ...prevData.realEstate,
          zipCode: inputValue,
        },
      }));
    }
  };

  useEffect(() => {
    const fetchDataFromAPI = () => {
      if (data.realEstate.zipCode.length === 5) {
        const apiUrl = `https://api.zippopotam.us/us/${data.realEstate.zipCode}`;
        axios
          .get(apiUrl)
          .then((res) => {
            if (res.data && res.data.places && res.data.places.length > 0) {
              const placeName = res.data.places[0]["place name"];

              setData((prevData) => ({
                ...prevData,
                realEstate: {
                  ...prevData.realEstate,
                  city: placeName,
                  country: res.data.country,
                  state: res.data.places[0]["state"],
                },
              }));
            } else {
            }
          })
          .catch((error) => {
            // toast.error("Failed to fetch address data from API.");
          });
      } else if (data.realEstate.zipCode.length > 5) {
        setData((prevData) => ({
          ...prevData,
          realEstate: {
            ...prevData.realEstate,
            zipCode: "",
            city: "",
            country: "",
            state: "",
          },
        }));
      } else if (data.realEstate.zipCode.length <= 4) {
        setData((prevData) => ({
          ...prevData,
          realEstate: {
            ...prevData.realEstate,
            city: "",
            country: "",
            state: "",
          },
        }));
      }
    };

    fetchDataFromAPI();
  }, [data.realEstate.zipCode]);

  // The rest of your code remains unchanged...

  const [popupVisible, setPopupVisible] = useState(false);
  const [selectedNote, setSelectedNote] = useState("");

  const handleOpenPopup = (note) => {
    setSelectedNote(note);
    setPopupVisible(true);
  };

  // add multiple mordgages
  const [mordgage, setMordgage] = useState([]);
  const [visibleColumnIndex, setVisibleColumnIndex] = useState(0);
  const mordgages = [0, 1, 2, 3, 4];
  const handleAddColumn = () => {
    if (visibleColumnIndex < 4) {
      setMordgage([...mordgage, { label: visibleColumnIndex + 1 }]);
      setVisibleColumnIndex(visibleColumnIndex + 1);
    }
  };

  const handleRemoveColumn = (indexToRemove) => {
    setMordgage(mordgage.filter((_, index) => index !== indexToRemove));
    setVisibleColumnIndex(visibleColumnIndex - 1);

    setData((prevData) => {
      const updatedMortgages = prevData.mortgages.map((mortgage, index) => {
        if (index === indexToRemove) {
          return { mortgage: "" }; // Reset the mortgage value to an empty string
        }
        return mortgage; // Return the original mortgage object for other indices
      });

      // Filter out mortgages with empty strings
      const filteredMortgages = updatedMortgages.filter(
        (mortgage) => mortgage.mortgage !== ""
      );

      // Return the new state with empty mortgages removed
      return {
        ...prevData,
        mortgages: filteredMortgages,
      };
    });
  };

  // for add field pop
  let [showAdditionField, SetshowAdditionField] = useState(false);

  //  downalod popup
  const [popupVisibleDownlaod, setPopupVisibleDownlaod] = useState(false);
  const [selectedDownlaod, setSelectDownload] = useState("");

  const handleShowDownlaod = (showDetail) => {
    setPopupVisibleDownlaod(true);
    setSelectDownload(showDetail);
  };

  // new update
  let [form1, setForm1] = useState(false);

  const toggle = () => {
    resetForm();
    setForm1(!form1);
  };

  let [card, setCard] = useState([]); // card = [ {} , {} , {}] - include the form data going to use it for card

  let [showDetail, setShowDetail] = useState([]); // this is to display the card details
  let [show, setShow] = useState(false);
  // card creating
  const AddCard = () => {
    let userId = getUser().commonId;
    let token = "Bearer " + getToken(); // Added 'Bearer'
    getRealEstates(token, userId)
      .then((res) => {
        setCard(res);
      })
      .catch((error) => {
        setCard([]);
        // toast.error("Card not created!!");
      });
  };

  // showing the details of cards like popup
  const Showdetails = (obj) => {
    // const arrayFromObject = Object.keys(obj).map(key => obj[key]);
    setShowDetail(obj);
    setShow(true);
  };

  // beneficiary addition in form
  const [beneficiary, setBenificiary] = useState([]);
  const getBenificiarydata = () => {
    let userId = getUser().commonId;

    let token = "Bearer " + getToken();
    getBeneficiary(token, userId)
      .then((res) => {
        setBenificiary(res);
      })
      .catch((err) => {});
  };

  const [trusts, setTrusts] = useState([]);
  const getTrustsData = () => {
    let userId = getUser().commonId;

    let token = "Bearer " + getToken();
    getTrustByUserId(token, userId)
      .then((res) => {
        setTrusts(res);
      })
      .catch((err) => {});
  };

  const validateZipCode = (value) => {
    return /^\d{5}$/.test(value); // Validates a 5-digit numeric input
  };

  const handleTrustSave = () => {
    setbeneVisible(false);
  };

  //
  const [benevisible, setbeneVisible] = useState(false);
  const [estimatedTotalAmount, setEstimatedTotalAmount] = useState(0);
  const [beneficiaryVisible, setBeneficiaryVisible] = useState(false);
  let [showAdditionField1, setshowAdditionField1] = useState(false);

  const handleShowBeneficiary = () => {
    setbeneVisible(true);
    setEstimatedTotalAmount(data.realEstate.estPropertyVal);
  };

  const handleCloseBeneficiaryPopup = (params) => {
    const { name } = params;
    if (name !== undefined) {
      setData((prevData) => ({
        ...prevData,
        sharedDetails: name,
      }));
    }
    setbeneVisible(false);
  };

  const handleReset = () => {
    setbeneVisible(false);
  };

  const getBenificiaryName = (id) => {
    var foundBenificiary = null;
    if (id.beneficiary === undefined) {
      foundBenificiary = beneficiary.find((b) => b.id === parseInt(id));
    } else {
      foundBenificiary = beneficiary.find(
        (b) => b.id === parseInt(id.beneficiary)
      );
    }

    if (foundBenificiary) {
      return `${foundBenificiary.firstName} ${foundBenificiary.lastName}`;
    } else {
      return "Benificiary not found"; // Or handle the case where beneficiary with the given ID isn't found
    }
  };

  const handleChanges1 = (e, field, { index }) => {
    const { value } = e.target;
    const errorStates = { ...errors };

    if (!errorStates.mortgages[index]) {
      errorStates.mortgages[index] = {
        mortgageAmountValidate: true,
      };
    }

    setData((prevData) => {
      const updatedMortgages = [...prevData.mortgages];
      if (!updatedMortgages[index]) {
        updatedMortgages[index] = {};
      }
      updatedMortgages[index][field] = value;

      return {
        ...prevData,
        mortgages: updatedMortgages,
      };
    });

    if (field === "mortgage") {
      errorStates.mortgages[index].mortgageAmountValidate =
        value !== "" ? validateEightDigitNumber(value) : true;
    }

    setErrors(errorStates);
  };

  const handleOpenBeneficiary = (showDetail) => {
    setBeneficiaryVisible(true);
  };

  useEffect(() => {
    AddCard();
    getBenificiarydata();
    getTrustsData();
  }, []);

  const maskCardNumber = (accountNumber) => {
    return "•".repeat(accountNumber.length);
  };

  const maskNumberRemaining4digits = (accountNumber) => {
    if (accountNumber.length <= 4) {
      return maskCardNumber(accountNumber);
    } else {
      const visibleDigits = accountNumber.slice(-4);
      const maskedDigits = "•".repeat(accountNumber.length - 4);
      return maskedDigits + visibleDigits;
    }
  };

  return (
    <>
      {primaryUserDetails.accountType === "secondary" &&
      secondaryUserDetails.accountType === "primary" &&
      secondaryUserDetails.isSecondaryUserEditable === "false" ? (
        ""
      ) : (
        <div className="addme">
          <div className="addme_inner">
            <button onClick={() => toggle()}>Add New Property</button>
          </div>
        </div>
      )}

      <div className="propCard">
        <div className="propCard-card">
          {card.map((entity) => (
            <div className="propCard-card-body" key={entity.realEstate.id}>
              <div className="propCard_card_status">
                <p
                  className={`propCard_card_status_text ${
                    entity.sharedDetails.length > 0 ||
                    (entity.realEstate.trust &&
                      entity.realEstate.trust !== "" &&
                      entity.realEstate.trust !== null)
                      ? "completed"
                      : "incomplete"
                  }`}
                >
                  {entity.sharedDetails.length > 0 ||
                  (entity.realEstate.trust &&
                    entity.realEstate.trust !== "" &&
                    entity.realEstate.trust !== null)
                    ? "completed"
                    : "incomplete"}
                </p>
              </div>
              <div 
                style={{ 
                  display: "flex", 
                  justifyContent: "space-between", 
                  alignItems: "flex-start", 
                  width: "100%" 
                }}
              >
                <h5 className="propCard-card-title">
                  {entity.realEstate.propertyCaption}
                </h5>

                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                  <span style={{ color: "green" }}>
                    {formatAmount(entity.realEstate.estPropertyVal)}
                  </span>
                  <span style={{ color: "red", marginTop: "2px" }}>
                    {formatAmount(entity.realEstate?.mortgage || 0)}
                  </span>
                </div>
              </div>
              <p className="propCard-card-text"> {entity.realEstate.city}</p>
              <div className="propCard-btn">
                <p className=" viewDetails">
                  <button onClick={() => Showdetails(entity)}>
                    View Details
                  </button>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {form1 && (
        <div className="overlay1" style={{ transition: "500ms", height: "" }}>
          <div className="addform_ichest">
            <div className="addform_main">
              <div className="addform_heading">
                <h3 className="addform_heading_h1">
                  Add Real Estate Properties
                </h3>
                <div className="addform_close" onClick={toggle}>
                  <FontAwesomeIcon icon={faXmark} />
                </div>
              </div>
              <div className="addform_body">
                <Form onSubmit={AddForm} className="addform_body">
                  <div className="addform_select_body">
                    <div className="addform_body_left">
                      <div>
                        <Tooltip title="Select Owner" className="mt-2">
                          <div>
                            <FormLabel required>Select Owner</FormLabel>

                            <Select
                              placeholder="Select Owner"
                              value={ownerName}
                              multiple
                              onChange={(event, newValue) =>
                                handleChange(event, newValue, "owner")
                              }
                              sx={{
                                minWidth: "13rem",
                              }}
                              slotProps={{
                                listbox: {
                                  sx: {
                                    width: "100%",
                                  },
                                },
                              }}
                              required
                            >
                              {ownerNames.map((name) => (
                                <Option key={name} value={name}>
                                  {name}
                                </Option>
                              ))}
                            </Select>
                          </div>
                        </Tooltip>
                      </div>

                      <div>
                        <Tooltip title="Enter Heading For Property ">
                          <div className="mt-2">
                            <FormLabel>Property Heading</FormLabel>
                            <Input
                              className="input_mui_joy"
                              placeholder="Enter property heading"
                              value={data.realEstate.propertyCaption}
                              onChange={(e) =>
                                handleChanges(e, "propertyCaption")
                              }
                            />
                          </div>
                        </Tooltip>
                      </div>

                      <div>
                        <Tooltip title="Select The Type Of Property">
                          <div className="mt-2">
                            <FormLabel required>Type Of Property</FormLabel>

                            <Select
                              value={data.realEstate.propertyType}
                              onChange={(event, newValue) =>
                                handleChange(event, newValue, "propertyType")
                              }
                              required
                            >
                              <Option value="">
                                Select Your Type Of Property
                              </Option>
                              <Option value="Residential">Residential</Option>
                              <Option value="Commercial">Commercial</Option>
                              <Option value="Industrial">Industrial</Option>
                              <Option value="Land">Land</Option>
                              <Option value="Other">Other</Option>
                            </Select>
                          </div>
                        </Tooltip>
                      </div>

                      {data.realEstate.propertyType === "Other" && (
                        <div className="mt-2">
                          <Tooltip title="Enter Your Other Property Type ">
                            <div>
                              <FormLabel>Other Property</FormLabel>
                              <Input
                                className="input_mui_joy"
                                placeholder="Enter Other Property"
                                id="otherprop"
                                onChange={(e) =>
                                  handleChanges(e, "otherPropertyType")
                                }
                                value={data.realEstate.otherPropertyType}
                              />
                            </div>
                          </Tooltip>
                        </div>
                      )}
                      <div className="address_input">
                        <div className="mt-2 addform_input_half">
                          <div>
                            <Tooltip title="Enter a valid Zip-code ">
                              <div>
                                <FormLabel required>Zip Code</FormLabel>
                                <Input
                                  className="input_mui_joy"
                                  type="number"
                                  placeholder="Enter your Zip Code"
                                  id="zipCode"
                                  onChange={(e) =>
                                    handleChangesZipCode(e, "zipCode")
                                  }
                                  value={data.realEstate.zipCode}
                                  inputprops={{
                                    minLength: 5,
                                    maxLength: 5,
                                  }}
                                  error={
                                    !validateZipCode(data.realEstate.zipCode)
                                  }
                                  required
                                />
                                {!validateZipCode(data.realEstate.zipCode) && (
                                  <Typography variant="caption" color="error">
                                    Please enter a valid 5-digit Zip Code
                                  </Typography>
                                )}
                              </div>
                            </Tooltip>
                          </div>
                        </div>

                        <div className="mt-2 addform_input_half">
                          <div>
                            <Tooltip title="Automatically populate based on the zip code">
                              <div style={{ width: "100%" }}>
                                <FormLabel>City/Town *</FormLabel>
                                <Input
                                  className="input_mui_joy"
                                  placeholder="City/Town *"
                                  value={data.realEstate.city}
                                  readOnly
                                  disabled
                                />
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                      </div>

                      <div className="address_input">
                        <div className="mt-2 addform_input_half">
                          <div>
                            <Tooltip title="Automatically populate based on the zip code">
                              <div>
                                <FormLabel>State *</FormLabel>
                                <Input
                                  className="input_mui_joy"
                                  placeholder="State *"
                                  value={data.realEstate.state}
                                  readOnly
                                  disabled
                                />
                              </div>
                            </Tooltip>
                          </div>
                        </div>

                        <div className="mt-2 addform_input_half">
                          <div>
                            <Tooltip title="Automatically populate based on the zip code">
                              <div>
                                <FormLabel>Country *</FormLabel>
                                <Input
                                  className="input_mui_joy"
                                  placeholder="Country *"
                                  value={data.realEstate.country}
                                  readOnly
                                  disabled
                                />
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                      <div className="address_input">
                        <div className="mt-2 addform_input_half">
                          <div>
                            <Tooltip title="Enter Your Street Address ">
                              <div style={{ width: "100%" }}>
                                <FormLabel>Street Address</FormLabel>
                                <Input
                                  className="input_mui_joy"
                                  placeholder="Street Address"
                                  onChange={(e) =>
                                    handleChanges(e, "streetAddress")
                                  }
                                  value={data.realEstate.streetAddress}
                                />
                              </div>
                            </Tooltip>
                          </div>
                        </div>

                        <div className="mt-2 addform_input_half">
                          <div>
                            <Tooltip title="Enter Your Apartment Number ">
                              <div style={{ width: "100%" }}>
                                <FormLabel>Apartment</FormLabel>
                                <Input
                                  className="input_mui_joy"
                                  placeholder="Apartment"
                                  onChange={(e) =>
                                    handleChanges(e, "aptNumber")
                                  }
                                  value={data.realEstate.aptNumber}
                                />
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                      <div className="address_input">
                        <div className="mt-2 addform_input_half">
                          <div>
                            <Tooltip title="Enter your estimated Property Value">
                              <div style={{ width: "100%" }}>
                                <FormLabel required>Property Value</FormLabel>
                                <Input
                                  type="number"
                                  className="input_mui_joy"
                                  placeholder="Estimated Property Value"
                                  onChange={(e) =>
                                    handleChanges(e, "estPropertyVal")
                                  }
                                  value={data.realEstate.estPropertyVal}
                                  startDecorator={<div>$</div>}
                                  required
                                />
                                {(!errors.estPropertyValValidate ||
                                  !errors.estPropertyValZeroValidate) && (
                                  <FormHelperText error>
                                    <Typography variant="caption" color="error">
                                      {!errors.estPropertyValValidate
                                        ? "Please enter a number up to 8 digits (maximum: $99,999,999)."
                                        : !errors.estPropertyValZeroValidate
                                        ? "Value can't be zero"
                                        : ""}
                                    </Typography>
                                  </FormHelperText>
                                )}
                              </div>
                            </Tooltip>
                          </div>
                        </div>

                        <div className="mt-2 addform_input_half">
                          <div>
                            <Tooltip title="Enter your Estimated Annual Property Tax">
                              <div style={{ width: "100%" }}>
                                <FormLabel>
                                  Annual Property Tax
                                </FormLabel>
                                <Input
                                  type="number"
                                  className="input_mui_joy"
                                  placeholder="Estimated Annual Property Tax"
                                  onChange={(e) =>
                                    handleChanges(e, "propertyTax")
                                  }
                                  value={data.realEstate.propertyTax}
                                  startDecorator={<div>$</div>}
                                />
                                {(!errors.propertyTaxValidate ||
                                  !errors.propertyTaxZeroValidate) && (
                                  <FormHelperText error>
                                    <Typography variant="caption" color="error">
                                      {!errors.propertyTaxValidate
                                        ? "Please enter a number up to 8 digits (maximum: $99,999,999)."
                                        : !errors.propertyTaxZeroValidate
                                        ? "Value can't be zero"
                                        : ""}
                                    </Typography>
                                  </FormHelperText>
                                )}
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                      <div className="mt-2 switch_changes_main">
                        <div className="switch_changes_base">
                          <div>
                            Do you want to include the asset value as part of
                            your net worth?
                          </div>
                          <div>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={
                                    data.realEstate.isPartOfNetWorth === "true"
                                      ? true
                                      : false
                                  }
                                  onChange={(e) =>
                                    handleChanges(e, "isPartOfNetWorth")
                                  }
                                  color="primary"
                                  size="normal"
                                />
                              }
                              label={
                                data?.realEstate?.isPartOfNetWorth === "true"
                                  ? "Yes"
                                  : "No"
                              }
                              labelPlacement="end"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="mt-2 switch_changes_main">
                                                                    <div className="switch_changes_base">
                                                                      <div>
                                                                        Do you want this asset to be visible to your agent?
                                                                      </div>
                                                                      <div>
                                                                        <FormControlLabel
                                                                          control={
                                                                            <Switch
                                                                              checked={
                                                                                data.realEstate.isPublic === "true" ||
                                                                                data.realEstate.isPublic === null
                                                                                  ? true
                                                                                  : false
                                                                              }
                                                                              onChange={(e) => handleChanges(e, "isPublic")}
                                                                              color="primary"
                                                                              size="normal"
                                                                            />
                                                                          }
                                                                          label={
                                                                            data.realEstate.isPublic === "true" ||
                                                                            data.realEstate.isPublic === null
                                                                              ? "Yes"
                                                                              : "No"
                                                                          }
                                                                          labelPlacement="end"
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  </div>
                    </div>

                    <div className="addform_body_right">
                      <div className="mt-2 switch_changes_main">
                        <div className="switch_changes_base">
                          <div>Do you have mortgages?</div>
                          <div>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={isChecked}
                                  onChange={handleSwitchChange}
                                  color="primary"
                                  size="normal"
                                />
                              }
                              label={isChecked ? "Yes" : "No"}
                              labelPlacement="end"
                            />
                          </div>
                        </div>
                      </div>
                      {isChecked && (
                        <div>
                          {mordgages.map((index) => (
                            <div
                              key={index}
                              style={{
                                marginBottom: "10px",
                                display:
                                  index <= visibleColumnIndex
                                    ? "block"
                                    : "none",
                              }}
                            >
                              <div>
                                <div>
                                  <Tooltip
                                    title={
                                      index === 0
                                        ? `Add your primary mortgage`
                                        : "Add your secondary mortgage"
                                    }
                                  >
                                    <div>
                                      {index === 0 ? (
                                        <FormLabel required>
                                          {`Primary Mortgage/Bank`}
                                        </FormLabel>
                                      ) : (
                                        <FormLabel required>
                                          {`Secondary Number/Bank`}
                                        </FormLabel>
                                      )}

                                      <Input
                                        className="input_mui_joy"
                                        placeholder={
                                          index === 0
                                            ? `Primary Mortgage`
                                            : "Secondary Number"
                                        }
                                        id={`mortgageInstitution${index + 1}`}
                                        required={visibleColumnIndex >= index}
                                        onChange={(e) =>
                                          handleChanges1(
                                            e,
                                            "mortgageInstitution",
                                            {
                                              index,
                                            }
                                          )
                                        }
                                        value={
                                          data.mortgages[index]
                                            ? data.mortgages[index]
                                                .mortgageInstitution
                                            : ""
                                        }
                                      />
                                    </div>
                                  </Tooltip>
                                </div>
                              </div>
                              <div className="address_input">
                                <div className="mt-2 addform_input_half">
                                  <Tooltip
                                    title={`Add your account number ${
                                      index + 1
                                    }`}
                                  >
                                    <div style={{ width: "100%" }}>
                                      <FormLabel required>
                                        {`Account Number ${index + 1}`}
                                      </FormLabel>
                                      <Input
                                        className="input_mui_joy"
                                        type="number"
                                        id={`accountNumber${index + 1}`}
                                        placeholder={`Account Number ${
                                          index + 1
                                        }`}
                                        onChange={(e) =>
                                          handleChanges1(e, "accountNumber", {
                                            index,
                                          })
                                        }
                                        value={
                                          data.mortgages[index]
                                            ? data.mortgages[index]
                                                .accountNumber
                                            : ""
                                        }
                                        required={visibleColumnIndex >= index}
                                      />
                                    </div>
                                  </Tooltip>
                                </div>
                                <div className="mt-2 addform_input_half">
                                  <Tooltip title={`Add your amount`}>
                                    <div>
                                      <FormLabel required>{`Amount`}</FormLabel>
                                      <Input
                                        className="input_mui_joy"
                                        type="number"
                                        placeholder="Amount"
                                        id={`mortgage${index + 1}`}
                                        required={visibleColumnIndex >= index}
                                        onChange={(e) =>
                                          handleChanges1(e, "mortgage", {
                                            index,
                                          })
                                        }
                                        value={
                                          data.mortgages[index]
                                            ? data.mortgages[index].mortgage
                                            : ""
                                        }
                                        startDecorator={<div>$</div>}
                                      />
                                      {errors.mortgages.length > index &&
                                        !errors?.mortgages[index]
                                          ?.mortgageAmountValidate && (
                                          <FormHelperText error>
                                            <Typography
                                              variant="caption"
                                              color="error"
                                            >
                                              Please enter a value up to 8
                                              digits (maximum: $99,999,999).
                                            </Typography>
                                          </FormHelperText>
                                        )}
                                    </div>
                                  </Tooltip>
                                </div>
                              </div>
                              {index !== 0 && (
                                <div style={{ marginTop: "4px" }}>
                                  <Button
                                    style={{
                                      height: "30px",
                                      width: "30px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      borderRadius: "50%",
                                      backgroundColor: "rgb(255, 74, 74)",
                                      border: "none",
                                    }}
                                    onClick={() => handleRemoveColumn(index)}
                                  >
                                    <FontAwesomeIcon icon={faMinus} />
                                  </Button>
                                </div>
                              )}
                            </div>
                          ))}
                          {visibleColumnIndex < 4 && (
                            <div style={{ marginTop: "2px" }}>
                              <Button
                                style={{
                                  height: "30px",
                                  width: "30px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRadius: "50%",
                                  backgroundColor: "#4aafff",
                                  border: "none",
                                }}
                                onClick={handleAddColumn}
                              >
                                <FontAwesomeIcon icon={faPlus} />
                              </Button>
                            </div>
                          )}
                        </div>
                      )}

                      <div className="address_input">
                        <div className="mt-2 addform_input_half">
                          <div
                            className="bene-select mt-3"
                            onClick={
                              data.realEstate?.estPropertyVal !== "" &&
                              parseFloat(data.realEstate?.estPropertyVal) > 0
                                ? handleShowBeneficiary
                                : null
                            }
                            style={{
                              cursor:
                                parseFloat(data.realEstate?.estPropertyVal) > 0
                                  ? "pointer"
                                  : "not-allowed",
                              opacity:
                                parseFloat(data.realEstate?.estPropertyVal) > 0
                                  ? 1
                                  : 0.6,
                            }}
                          >
                            Select Beneficiary
                          </div>
                        </div>

                        <div className="mt-2 addform_input_half">
                          <div style={{ width: "100%" }}>
                            <Tooltip title="Upload your property related file it should be under 400 kb">
                              <div>
                                <FormLabel>Supporting Document</FormLabel>
                                <input
                                  style={{
                                    border: "solid 1px lightgray",
                                    borderLeft: "none",
                                    width: "100%",
                                    borderRadius: "2px",
                                  }}
                                  type="file"
                                  name="myfile"
                                  id="exampleFile"
                                  onChange={handleImageChange}
                                  accept=".pdf"
                                  multiple
                                />
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                      <div
                        className="mt-2 form1-double"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          justifyContent: "space-between",
                          marginTop: "-12px",
                        }}
                      ></div>

                      <div className="address_input">
                        <div style={{ width: "100%" }} className="mt-2">
                          <div>
                            <FormLabel>Notes</FormLabel>
                            <Textarea
                              sx={{ height: "182px", minHeight: "52px" }}
                              placeholder="Notes"
                              id="notes"
                              onChange={(e) => handleChanges(e, "notes")}
                              value={data.realEstate.notes}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center">
                    <Button
                      className="my-estate-clear-btn"
                      onClick={resetForm}
                      type="button"
                      outline
                    >
                      Clear
                    </Button>
                    <Button outline type="submit" className="my-estate-add-btn">
                      Add
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* displaying the pop table for cards */}

      {show && Object.keys(showDetail).length > 0 && (
        <>
          <div className="card__data" style={{ transition: "all 1s ease-out" }}>
            <div className="card__data-container">
              <section className="section1">
                <div>
                  <p className="row1-text">
                    <FontAwesomeIcon
                      icon={faHouse}
                      style={{ color: "#025596", fontSize: "18px" }}
                    />
                    <span style={{}}>
                      {showDetail.realEstate.propertyCaption}
                    </span>
                  </p>
                  <div className="row1-button">
                    <div>
                      {showDetail.documents &&
                        showDetail.documents.length > 0 && (
                          <Tooltip title="click to see multiple downlaod files">
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleShowDownlaod(showDetail);
                                setShow(false);
                              }}
                            >
                              <div className="myestate_download_button dwnbtn">
                                <FontAwesomeIcon
                                  className="myestate_download_icon"
                                  icon={faDownload}
                                />
                                <span></span>
                              </div>
                            </div>
                          </Tooltip>
                        )}
                    </div>

                    {primaryUserDetails.accountType === "secondary" &&
                    secondaryUserDetails.accountType === "primary" &&
                    secondaryUserDetails.isSecondaryUserEditable === "false" ? (
                      ""
                    ) : (
                      <div>
                        <Tooltip title="Click Here To Edit">
                          <div>
                            <UpdateButton
                              URL={"../my-estate/real-estate/"}
                              id={showDetail.realEstate.id}
                            />
                          </div>
                        </Tooltip>
                      </div>
                    )}

                    {primaryUserDetails.accountType === "secondary" &&
                    secondaryUserDetails.accountType === "primary" &&
                    secondaryUserDetails.isSecondaryUserEditable === "false" ? (
                      ""
                    ) : (
                      <div>
                        <FontAwesomeIcon
                          onClick={() =>
                            removeRealEstate(
                              showDetail.realEstate.id,
                              "realEstateId"
                            )
                          }
                          className="delete-button-comp"
                          style={{ cursor: "pointer" }}
                          icon={faTrash}
                        />
                      </div>
                    )}

                    <div>
                      <span
                        className="card__data-close"
                        onClick={() => {
                          setShow(!show);
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </span>
                    </div>
                  </div>
                </div>
              </section>

              <section className="section2">
                <div>
                  <div className="col1">
                    {showDetail.realEstate.owner && (
                      <p>
                        Owner : <code>{showDetail.realEstate.owner}</code>
                      </p>
                    )}

                    {showDetail.realEstate.propertyType === "Other" ? (
                      ""
                    ) : (
                      <p>
                        Type of Property:{" "}
                        <code> {showDetail.realEstate.propertyType}</code>
                      </p>
                    )}

                    {showDetail.realEstate.propertyType === "Other" && true ? (
                      <p>
                        Other Type of Property:{" "}
                        <code> {showDetail.realEstate.otherPropertyType}</code>
                      </p>
                    ) : (
                      ""
                    )}
                    <p>
                      Street Address:{" "}
                      <code>{showDetail.realEstate.streetAddress}</code>
                    </p>

                    {showDetail.realEstate.aptNumber && (
                      <p>
                        Apartment:{" "}
                        <code>{showDetail.realEstate.aptNumber}</code>
                      </p>
                    )}
                    <p>
                      Zip Code: <code>{showDetail.realEstate.zipCode}</code>
                    </p>
                    <p>
                      City / Town: <code>{showDetail.realEstate.city}</code>
                    </p>
                    <p>
                      State: <code>{showDetail.realEstate.state}</code>
                    </p>
                  </div>
                  <div className="col2">
                    <p>
                      Country: <code>{showDetail.realEstate.country}</code>
                    </p>
                    {showDetail.name === null ? (
                      <p>
                        Supporting Document:{" "}
                        <Tooltip
                          title="No document addded"
                          style={{ color: "red" }}
                        >
                          <FontAwesomeIcon
                            icon={faTriangleExclamation}
                            style={{ color: "orange" }}
                          />
                        </Tooltip>
                      </p>
                    ) : (
                      ""
                    )}

                    <p>
                      Estimated Equity:{" "}
                      <code>
                        {" "}
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          {" "}
                          {formatAmount(showDetail.realEstate.equity)}
                        </span>
                      </code>
                    </p>

                    <p>
                      Estimated Annual Property Tax:
                      <code style={{ color: "red", fontWeight: "bold" }}>
                        {" "}
                        {formatAmount(showDetail.realEstate.propertyTax)}
                      </code>
                    </p>

                    {showDetail?.mortgages[0] && (
                      <Tooltip title={`Click To See Details`}>
                        <p
                          onClick={() => {
                            setshowAdditionField1(showDetail);
                          }}
                        >
                          Mortgages Details:&nbsp;
                          <code>
                            <span className="readmore">Click to see</span>
                          </code>
                        </p>
                      </Tooltip>
                    )}

                    {showDetail.benificiary && (
                      <p>
                        Beneficiary Name: <code>{showDetail.benificiary}</code>
                      </p>
                    )}

                    <p>
                      Estimate Property Value:{" "}
                      <code style={{ color: "green", fontWeight: "bold" }}>
                        {formatAmount(showDetail.realEstate.estPropertyVal)}
                      </code>
                    </p>

                    {showDetail.realEstate.updatedDate && (
                      <p style={{ fontSize: "13px", marginTop: "6px" }}>
                        <strong>Last Updated:</strong>{" "}
                        <code style={{ color: "#333", fontWeight: "400" }}>
                          {formatDateTimeUS(showDetail.realEstate.updatedDate)}
                        </code>
                      </p>
                    )}

                    {showDetail.sharedDetails[0] && (
                      <p
                        onClick={() => {
                          handleOpenBeneficiary(showDetail);
                        }}
                      >
                        Beneficiary Details{" "}
                        <code>
                          <span className="readmore">Click Here</span>
                        </code>
                      </p>
                    )}

                    {showDetail.realEstate.trust && (
                      <p>
                        Trust Name: <code>{showDetail.realEstate.trust}</code>
                      </p>
                    )}

                    {showDetail.realEstate.notes && (
                      <Tooltip title="Click To see Note">
                        <p
                          onClick={() => {
                            handleOpenPopup(showDetail.realEstate.notes);
                            setShow(!show);
                          }}
                        >
                          Note:{" "}
                          <code>
                            {showDetail && showDetail.realEstate.notes
                              ? showDetail.realEstate.notes.slice(0, 10)
                              : ""}
                            ...<span className="readmore">Read More</span>
                          </code>
                        </p>
                      </Tooltip>
                    )}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </>
      )}

      {showConfirmation && (
        <Deletebutton
          handleRemove={handleRemove}
          Id={currentId}
          idType={currentIdType}
          handleConfirmationClose={handleConfirmationClose}
        />
      )}

      {/*  download popup */}
      {popupVisibleDownlaod && (
        <div className="popup">
          <div className="popup-content popup-content-download">
            <div className="note_popup">
              <div className="note_popup_heading">
                <div style={{ textAlign: "center", width: "100%" }}>
                  <h2>Download Files</h2>
                </div>
                <div>
                  <button
                    className="note_popup_heading_close_btn"
                    onClick={() => {
                      setPopupVisibleDownlaod(false);
                    }}
                  >
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                </div>
              </div>

              <div>
                {selectedDownlaod.documents &&
                  selectedDownlaod.documents.length > 0 &&
                  selectedDownlaod.documents.map((file, index) => (
                    <div key={index} style={{ marginBottom: "20px" }}>
                      <Tooltip title={file.fileName}>
                        <div
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            gap: "20px",
                          }}
                          onClick={() => {
                            handleDownload(file.id, file.fileName);
                          }}
                        >
                          Download - {index + 1}
                          <div className="myestate_download_button dwnbtn">
                            <FontAwesomeIcon
                              className="myestate_download_icon"
                              icon={faDownload}
                            />
                            <span>{file.fileName}</span>
                          </div>
                        </div>
                      </Tooltip>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {popupVisible && (
        // Popup div
        <div className="popup">
          <div className="popup-content">
            <div className="note_popup">
              <div className="note_popup_heading">
                <div>
                  <h2>Note</h2>
                </div>
                <div>
                  <button
                    className="note_popup_heading_close_btn"
                    onClick={() => {
                      setPopupVisible(false);
                      setShow(!show);
                    }}
                  >
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                </div>
              </div>
              <div>
                <p>{selectedNote}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {showAdditionField && (
        // Display the popup when a row is selected
        <div className="popup">
          <div className="popup-content">
            <div className="note_popup_heading">
              <div>
                <h2>All Additional Field</h2>
              </div>
              <div>
                <button
                  className="note_popup_heading_close_btn"
                  onClick={() => {
                    SetshowAdditionField(false);
                    setShow(!show);
                  }}
                >
                  <FontAwesomeIcon icon={faXmark} />
                </button>
              </div>
            </div>
            <div className="popup-body">
              {showAdditionField.addfield1 !== 0 &&
              showAdditionField.addfield1 !== "" ? (
                <p
                  style={{ fontWeight: 450, fontSize: "12px", color: "black" }}
                >
                  New Field 1 : {showAdditionField.addfield1}
                </p>
              ) : (
                <p></p>
              )}
              {showAdditionField.addfield2 !== 0 &&
              showAdditionField.addfield2 !== "" ? (
                <p
                  style={{ fontWeight: 450, fontSize: "12px", color: "black" }}
                >
                  New Field 2 : {showAdditionField.addfield2}
                </p>
              ) : (
                <p></p>
              )}
              {showAdditionField.addfield3 !== 0 &&
              showAdditionField.addfield3 !== "" ? (
                <p
                  style={{ fontWeight: 450, fontSize: "12px", color: "black" }}
                >
                  New Field 3 : {showAdditionField.addfield3}
                </p>
              ) : (
                <p></p>
              )}
              {showAdditionField.addfield4 !== 0 &&
              showAdditionField.addfield4 !== "" ? (
                <p
                  style={{ fontWeight: 450, fontSize: "12px", color: "black" }}
                >
                  New Field 4 : {showAdditionField.addfield4}
                </p>
              ) : (
                <p></p>
              )}
              {showAdditionField.addfield5 !== 0 &&
              showAdditionField.addfield5 !== "" ? (
                <p
                  style={{ fontWeight: 450, fontSize: "12px", color: "black" }}
                >
                  New Field 5 : {showAdditionField.addfield5}
                </p>
              ) : (
                <p></p>
              )}
            </div>
          </div>
        </div>
      )}

      {beneficiaryVisible && (
        <div className="popup">
          <div className="popup-content popup-content-download">
            <div className="note_popup">
              <div className="note_popup_heading">
                <div style={{ textAlign: "center", width: "100%" }}>
                  <h2>share property</h2>
                </div>
                <div>
                  <button
                    className="note_popup_heading_close_btn"
                    onClick={() => {
                      setBeneficiaryVisible(false);
                    }}
                  >
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                </div>
              </div>
              <div>
                {showDetail.sharedDetails &&
                  showDetail.sharedDetails.map((details, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        margin: "5px",
                        padding: "10px",
                        border: "solid 1px lightgray",
                        borderRadius: "5px",
                        minWidth: "230px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "17px",
                            color: "black",
                            fontWeight: "500",
                          }}
                        >
                          Share - {index + 1}
                        </p>
                        {primaryUserDetails.accountType === "secondary" &&
                        secondaryUserDetails.accountType === "primary" &&
                        secondaryUserDetails.isSecondaryUserEditable ===
                          "false" ? (
                          ""
                        ) : (
                          <FontAwesomeIcon
                            onClick={() =>
                              removeRealEstate(details.id, "sharedDetailId")
                            }
                            className="delete-button-comp"
                            style={{ cursor: "pointer" }}
                            icon={faTrash}
                          />
                        )}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginLeft: "20px",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "400",
                            marginLeft: "20px",
                          }}
                        >
                          Beneficiary Name:
                          <span style={{ marginLeft: "10px" }}>
                            {getBenificiaryName(details.beneficiaryId)}
                          </span>
                        </p>
                        <p
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "400",
                            marginLeft: "20px",
                          }}
                        >
                          Distributed Type:
                          <span style={{ marginLeft: "10px" }}>
                            {details.distributedType}
                          </span>
                        </p>
                        <p
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "400",
                            marginLeft: "20px",
                          }}
                        >
                          Distributed Value:{" "}
                          <span style={{ marginLeft: "10px" }}>
                            {details &&
                              details.distributedType === "dollar" &&
                              "$"}
                            {details.distributedValue}
                            {details.distributedType === "percentage" && "%"}
                          </span>
                        </p>
                        <p
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "400",
                            marginLeft: "20px",
                          }}
                        >
                          Distributed Amount:
                          <span style={{ marginLeft: "10px" }}>
                            {formatAmount(details.distributedAmount)}
                          </span>
                        </p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {showAdditionField1 && (
        // Display the popup when a row is selected
        <div className="popup">
          <div className="popup-content popup-content-download">
            <div className="note_popup">
              <div className="note_popup_heading">
                <div style={{ width: "100%" }}>
                  <h2 style={{ textAlign: "center" }}>Mortgages Details</h2>
                </div>
                <div>
                  <button
                    className="note_popup_heading_close_btn"
                    onClick={() => {
                      setshowAdditionField1(false);
                    }}
                  >
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                </div>
              </div>
              {showDetail.mortgages &&
                showDetail.mortgages.map((mortgageList, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "5px",
                      padding: "10px",
                      border: "solid 1px lightgray",
                      borderRadius: "5px",
                      minWidth: "230px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {index === 0 ? (
                        <p
                          style={{
                            fontSize: "17px",
                            color: "black",
                            fontWeight: "500",
                          }}
                        >
                          Primary Mortgage
                        </p>
                      ) : (
                        <p
                          style={{
                            fontSize: "17px",
                            color: "black",
                            fontWeight: "500",
                          }}
                        >
                          Secondary Mortgage
                        </p>
                      )}
                     
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: "20px",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "15px",
                          color: "black",
                          fontWeight: "400",
                          marginLeft: "20px",
                        }}
                      >
                        Amount:
                        <span style={{ marginLeft: "10px", fontWeight: "500" }}>
                          {formatAmount(mortgageList.mortgage)}
                        </span>
                      </p>

                      {index === 0 ? (
                        <p
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "400",
                            marginLeft: "20px",
                          }}
                        >
                          Primary Mortgage/Bank:
                          <span
                            style={{ marginLeft: "10px", fontWeight: "500" }}
                          >
                            {mortgageList.mortgageInstitution}
                          </span>
                        </p>
                      ) : (
                        <p
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "400",
                            marginLeft: "20px",
                          }}
                        >
                          Secondary Mortgage/Bank:
                          <span
                            style={{ marginLeft: "10px", fontWeight: "500" }}
                          >
                            {mortgageList.mortgageInstitution}
                          </span>
                        </p>
                      )}

                      <p
                        style={{
                          fontSize: "15px",
                          color: "black",
                          fontWeight: "400",
                          marginLeft: "20px",
                        }}
                      >
                        Account Number:
                        <span style={{ marginLeft: "10px", fontWeight: "500" }}>
                          {maskNumberRemaining4digits(
                            mortgageList.accountNumber
                          )}
                        </span>
                      </p>
                    </div>
                  </div>
                ))}
            </div>

            {/* <div style={{ display: "flex", flexWrap: "wrap", flexDirection: "row", }} > */}

            {/* </div> */}
          </div>
        </div>
      )}

      {benevisible && (
        <SharedBeneficiary
          handleTrustSave={handleTrustSave}
          assetData={data?.realEstate}
          trusts={trusts}
          handleChanges={handleChanges}
          sharedType={sharedType}
          handleCloseBeneficiaryPopup={handleCloseBeneficiaryPopup}
          estimatedTotalAmount={estimatedTotalAmount}
          typeBeneficiary={"normal"}
          sharedDetails={data?.sharedDetails}
        />
      )}
    </>
  );
}

export default RealEstateContent;